import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _has from 'lodash/has';
import { AppContext, UserContext } from 'commons-ui';
import useService from '../../../useService';
import { Record } from '../../../helper';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { user } = useContext(UserContext);
	const { requestUpdateSegment } = useService();

	const updateSegmentInfo = async (updatedData: Record) => {
		setShowLoader(true);
		try {
			const updateSegmentData: Record = { ...updatedData };
			const currDate = Date.now();
			const userEmail = String(user?.email);
			updateSegmentData.updatedAt = currDate;
			updateSegmentData.updatedBy = userEmail;
			if (_has(updateSegmentData, 'id')) {
				delete updateSegmentData.id;
			}
			if (_has(updateSegmentData, 'index')) {
				delete updateSegmentData.index;
			}
			if (_has(updateSegmentData, 'updatedAt')) {
				delete updateSegmentData.updatedAt;
			}
			const response: boolean = await requestUpdateSegment(updateSegmentData, showAlert);
			if (response) history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: Record) => {
		updateSegmentInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
